export default "__VITE_ASSET__BgIOw33x__"